import { gql } from "@apollo/client";
import { useMutation } from "@apollo/client/react";

import DeletePricelist from "./DeletePricelist.graphql";

export default function useDeletePricelist() {
    return useMutation(gql(DeletePricelist));
}
